import { type ReactElement } from 'react'
import { getName, type UserProfileData } from '@terros/common'
import { Group, type MantineBreakpoint, Text } from '@mantine/core'
import { Size, useBackend, useTranslation } from '@front/model'
import { useAuth0 } from '@auth0/auth0-react'
import { PrefetchedUserInfo } from '../entityInfo'
import { TButton } from '../buttons'
import { ButtonSignOut } from './signout'

type Props = {
  user?: UserProfileData
  visibleFrom?: MantineBreakpoint
  hiddenFrom?: MantineBreakpoint
}

export const UserSection = ({ user, visibleFrom, hiddenFrom }: Props): ReactElement => {
  const { loginWithRedirect } = useAuth0()
  const { isAuthenticated } = useBackend()
  const { t } = useTranslation()

  return isAuthenticated() ? (
    <Group flex='none' justify='flex-end' visibleFrom={visibleFrom} hiddenFrom={hiddenFrom}>
      {user && (
        <Group gap={Size.space['2xl']}>
          <PrefetchedUserInfo avatarOnly user={user} />
          <Text hiddenFrom='sm'>{getName(user)}</Text>
        </Group>
      )}
      <ButtonSignOut />
    </Group>
  ) : (
    <TButton onClick={() => loginWithRedirect()}>{t('Sign In')}</TButton>
  )
}
